export default function Hero() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/98020ffb9564aa7e5ba757976699728f.jpg"
          alt="TMI Operations"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-24 text-center text-white">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 font-['Montserrat']">
          About Tlotlo Mfolwe Incorporated
        </h1>
        <p className="text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed font-light">
          Building Southern Africa's future through excellence in mining and logistics since 2008
        </p>
      </div>
    </section>
  );
}
